import { render, staticRenderFns } from "./List.vue?vue&type=template&id=596618f8&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "@/components/catalog/items/styles/list.scss?vue&type=style&index=0&id=596618f8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596618f8",
  null
  
)

export default component.exports